import { Deletable } from '../interface/deletable'
import { Factory } from '../interface/factory'
import { Identifiable } from '../interface/identifiable'
import { Modifiable } from '../interface/modifiable'
import { I18nString } from './i18nstring'
import { Settings } from './settings'
import { applyEntitySchema } from '../../_utils/fcdc-v2'
import { isPlainObject } from '../../_utils/fcdc-v2/json'
import { coordinatesSchema, LocationSchema } from '../schema/owners.schema'

export class Coordinates {
  latitude: number
  longitude: number

  constructor(json: any) {
    this.latitude = json?.latitude
    this.longitude = json?.longitude
    applyEntitySchema(this, coordinatesSchema, json, {
      latitude: undefined,
      longitude: undefined,
    })
  }

  toJSON(): Record<string, unknown> {
    const body: Record<string, unknown> = {}
    if (this.latitude !== undefined) {
      body['latitude'] = this.latitude
    }
    if (this.longitude !== undefined) {
      body['longitude'] = this.longitude
    }
    return body
  }
}

export class Location implements Modifiable, Deletable, Identifiable {
  id: string
  siteId: string

  settings?: Settings

  names: I18nString[]

  coordinates?: Coordinates

  deleted?: boolean
  created: Date
  modified: Date

  constructor(json: any) {
    this.id = json.id
    this.siteId = json.siteId

    this.settings = isPlainObject(json.settings)
      ? new Settings(json.settings)
      : undefined
    this.names = Array.isArray(json.names)
      ? json.names.map((name: any) => new I18nString(name))
      : []

    this.coordinates = isPlainObject(json.coordinates)
      ? new Coordinates(json.coordinates)
      : undefined

    this.deleted = json.deleted ? Boolean(json.deleted) : false
    this.created = new Date(json.created)
    this.modified = new Date(json.modified)
    applyEntitySchema(this, LocationSchema, json, {
      names: [],
      settings: undefined,
      coordinates: undefined,
    })
  }

  public static getFactory(): Factory<Location> {
    return new (class implements Factory<Location> {
      make(json: any): Location {
        return new Location(json)
      }

      getTableName(): string {
        return 'locations'
      }
    })()
  }

  static getUrl(siteId: string, locationId?: string): string {
    return (
      '/sites/' + siteId + '/locations' + (locationId ? '/' + locationId : '')
    )
  }
}
